import React from "react";
import { Card, CardImg, TextContainer } from "./index.styled";

const AvanegarFeaturesCard = ({ features }) => {
  const { icon, content } = features;
  return (
    <Card>
      <CardImg>
        <img src={icon} alt="icon" />
      </CardImg>
      <TextContainer width="287.15px" height="72px">
        <p color="#51515C">{content}</p>
      </TextContainer>
    </Card>
  );
};

export default AvanegarFeaturesCard;
